import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const eavesdropping = [
  new Dialog(
    "SONNY YANG: Sounds like someone’s having a conference call on the toilet. Let’s take a listen...",
    require("@/images/Dareths_Upstairs_Corridor.png"),
    require("@/audio/Pandemic-61-Sonny-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: Yeah brother life is good! I’m getting paid fat bucks to have a nice relaxing quarantine at home while all our so - called ‘ESSENTIAL EMPLOYEES’ have to risk life and limb by heading into work! Here’s to being MIDDLE MANAGEMENT hey brother!",
    require("@/images/Dareth_with_Phone.png"),
    require("@/audio/Pandemic-61-Dareth-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Why if it isn’t Dareth Schamren himself! Perhaps he ought to receive a taste of his own medicine...",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-61-Sonny2-MP3.mp3")
  ),
];

export class DarethsUpstairs extends Scene {
  title = "Dareth's Upstairs Corridor";

  async init() {
    if (this.state.storylines.darethDemoted) {
      this.image = require("@/images/Dareths_Upstairs_Corridor.png");
      this.description = "";
      this.audio = null;
    } else if (!this.state.storylines.eavesdropped) {
      await this.dialogRunner(eavesdropping)
      this.state.storylines.eavesdropped = true;
      this.init();
    } else {
      this.image = require("@/images/Dareths_Upstairs_Corridor.png");
      this.audio = null;
      this.description = "";
    }
  }

  get options(): any[] {
    return [
      new Choice("Look in Bathroom", async () => {
        if (this.state.storylines.darethDemoted) {
          await this.navigate(scenes.DarethsBathroom());
        } else {
          this.description = "[THE DOOR IS LOCKED]";
        }
      }),
      new Choice("Look in Bedroom", async () =>
        await this.navigate(scenes.DarethsBedroom())
      ),
      new Choice("Go Back", async () => await this.navigate(scenes.DarethsFoyer())),
    ];
  }
}

export default new DarethsUpstairs();
